import AjaxURL from '../common/AjaxURL';

$.validator.addMethod(
    'qasEmailValidationRequired',
    function emailValidation(value, element) {
      const newValue = $.trim((value || ''));
      const $element = $(element);
      if ((newValue === undefined) || (newValue === null) || (newValue === '')) {
        if ($element.hasClass('required') === true) {
          return false;
        }

        return true;
      }
      if ($element.is(':focus') === true) {
        return true;
      }

      const token = $('.AntiForgeryToken').val();

      const result = $.validator.methods.remote.call(this, value, element, {
        url: AjaxURL.ecomBag,
        data: { task: 'validateEmailAddress', c: OCMS.GlobalVars.C, l: OCMS.GlobalVars.L, email: value, AntiForgeryToken: token },
        dataType: 'json',
        type: 'post',
      });

      const input = $("[id$='qasEmailIsValidated']");
      if (result === true) {
        input.val('true');
      } else {
        input.val('false');
      }

      return result;
    }
);



// WEBPACK FOOTER //
// ./js/plugins/qas.email-validator.js